import {
  Autocomplete,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  LinearProgress,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import VirtualizedAutocomplete from "../../virtualization/virtualizedAutocomplete";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import dayjs from "dayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import MentionTextField from "../../textfieldMention";
import api from "../../../services/api";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { FixedSizeList } from "react-window";
export default function EditOsComponent(params) {
  const {
    loadingParams = false,
    loadingCreateOs = false,
    tipoOs = [],
    statusOs = [],
    tecnicos = [],
    paramsAberturaOs = {},
    error = false,
    setDisponibilidadeSelecionada = () => {},
    disponibilidade = [],
    disponibilidadeSelecionada = [],
    setParamsAberturaOs = () => {},
    setTecnicosSelecionados = () => {},
    tecnicosSelecionados = [],
    dataInicioProgramada = null,
    dataTerminoProgramada = null,
    agenda = [],
    prioridades = [],
    editOs = true,
    setDateEdited = () => {},
    idClienteServico = null,
    setTipoAgendamento = () => {},
    tipoAgendamento = "manual",
    // Id do ERP escolhido na tela; vai no body das rotas.
    erpId,
  } = params;
  const theme = useTheme();

  const styles = useStyles(theme);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [agendaOsAutomatico, setAgendaOsAutomatico] = useState([]);
  const [loadingAgenda, setLoadingAgenda] = useState(false);
  const [datasOsAutomatica, setDatasOsAutomatica] = useState([]);
  const [dataSelecionada, setDataSelecionada] = useState("");
  const [horaSelecionada, setHoraSelecionada] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [open, setOpen] = useState(false);
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;
  useEffect(() => {
    // 1. Verificamos se ambas as datas existem e são objetos dayjs válidos
    const datesAreValid =
      startDate &&
      dayjs(startDate).isValid() &&
      endDate &&
      dayjs(endDate).isValid();

    if (datesAreValid) {
      // 2. Validação de Regra de Negócio:
      // - isAfter: Garante que Fim > Início (se forem iguais, retorna false)
      // - isWithin24Hours: Garante que o intervalo é <= 24h
      const isEndDateAfterStart = dayjs(endDate).isAfter(dayjs(startDate));

      const isWithin24Hours =
        dayjs(endDate).isBefore(dayjs(startDate).add(24, "hour")) ||
        dayjs(endDate).isSame(dayjs(startDate).add(24, "hour"));

      if (isEndDateAfterStart && isWithin24Hours) {
        setParamsAberturaOs((prev) => ({
          ...prev,
          data_inicio_programado: dayjs(startDate).format("YYYY-MM-DD"),
          data_termino_programado: dayjs(endDate).format("YYYY-MM-DD"),
          hora_inicio_programado: dayjs(startDate).format("HH:mm:ss"),
          hora_termino_programado: dayjs(endDate).format("HH:mm:ss"),
        }));
      } else {
        // Entra aqui se: datas forem iguais, fim for antes do início ou intervalo > 24h
        setParamsAberturaOs((prev) => ({
          ...prev,
          data_inicio_programado: null,
          data_termino_programado: null,
          hora_inicio_programado: null,
          hora_termino_programado: null,
        }));
      }
    } else {
      // Caso as datas não estejam preenchidas ou sejam inválidas
      setParamsAberturaOs((prev) => ({
        ...prev,
        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
      }));
    }
  }, [startDate, endDate]);
  useEffect(() => {
    setStartDate(dataInicioProgramada ? dayjs(dataInicioProgramada) : null);
    setEndDate(dataTerminoProgramada ? dayjs(dataTerminoProgramada) : null);
  }, []);
  useEffect(() => {
    if (!editOs) {
      if (tipoAgendamento === "automatico") {
        setStartDate(null);
        setEndDate(null);

        setParamsAberturaOs((prev) => ({
          ...prev,
          statusOs: "pendente",
          data_inicio_programado: null,
          data_termino_programado: null,
          hora_inicio_programado: null,
          hora_termino_programado: null,
          agenda: { id: null, descricao: null },
          tecnicos: [],
        }));
      } else {
        setParamsAberturaOs((prev) => ({
          ...prev,
          statusOs: "",
          data_inicio_programado: null,
          data_termino_programado: null,
          hora_inicio_programado: null,
          hora_termino_programado: null,
          agenda: { id: null, descricao: null },
          tecnicos: [],
        }));

        setTecnicosSelecionados([]);
        setDataSelecionada("");
        setHoraSelecionada("");
      }
    }
  }, [tipoAgendamento]);

  useEffect(() => {
    if (tipoAgendamento === "automatico") {
      setParamsAberturaOs((prev) => ({
        ...prev,

        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        agenda: { id: null, descricao: null },
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);
      setDataSelecionada("");
      setHoraSelecionada("");
    }
  }, [paramsAberturaOs?.tipoOs?.id]);

  /* ################################################################################################# */
  useEffect(() => {
    const controller = new AbortController();

    if (
      paramsAberturaOs?.tipoOs?.id &&
      idClienteServico &&
      tipoAgendamento === "automatico"
    ) {
      getAgendaOsAutomatico(controller.signal);
    }

    return () => {
      controller.abort();
    };
  }, [paramsAberturaOs?.tipoOs?.id, idClienteServico, tipoAgendamento]);

  useEffect(() => {
    const controller = new AbortController();

    if (
      paramsAberturaOs?.agenda?.id &&
      paramsAberturaOs?.tipoOs?.id &&
      idClienteServico &&
      tipoAgendamento === "automatico"
    ) {
      getHorariosDisponiveis(controller.signal);
    }

    return () => {
      controller.abort();
    };
  }, [
    paramsAberturaOs?.agenda?.id,
    paramsAberturaOs?.tipoOs?.id,
    idClienteServico,
  ]);

  useEffect(() => {
    if (tipoAgendamento === "automatico" && paramsAberturaOs?.agenda?.id) {
      setParamsAberturaOs((prev) => ({
        ...prev,

        data_inicio_programado: null,
        data_termino_programado: null,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);
      setDataSelecionada("");
      setHoraSelecionada("");
    }
  }, [paramsAberturaOs?.agenda?.id]);
  useEffect(() => {
    if (
      tipoAgendamento === "automatico" &&
      paramsAberturaOs?.data_inicio_programado
    ) {
      setParamsAberturaOs((prev) => ({
        ...prev,
        hora_inicio_programado: null,
        hora_termino_programado: null,
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);

      setHoraSelecionada("");
    }
  }, [paramsAberturaOs?.data_inicio_programado]);
  useEffect(() => {
    if (
      tipoAgendamento === "automatico" &&
      paramsAberturaOs?.hora_inicio_programado
    ) {
      setParamsAberturaOs((prev) => ({
        ...prev,
        tecnicos: [],
      }));
      setTecnicosSelecionados([]);
    }
  }, [paramsAberturaOs?.hora_inicio_programado]);
  /* ################################################################################################# */
  const handleChangeDataOs = (event) => {
    const objectData = event.target.value;

    // Atualiza o estado com o objeto inteiro
    setDataSelecionada(objectData);
    setParamsAberturaOs((prev) => ({
      ...prev,
      data_inicio_programado: objectData.data,
      data_termino_programado: objectData.data,
    }));
  };

  const handleChangeHorarioOs = (event) => {
    const objectHorario = event.target.value;

    // Atualiza o estado com o objeto inteiro
    setHoraSelecionada(objectHorario);
    setParamsAberturaOs((prev) => ({
      ...prev,
      hora_inicio_programado: objectHorario.hora_inicio,
      hora_termino_programado: objectHorario.hora_termino,
    }));
  };
  const getAgendaOsAutomatico = async (signal) => {
    setLoadingAgenda(true);
    try {
      const response = await api.post(
        "/interno/find/agendaOsAutomatica",
        {
          idTipoOs: paramsAberturaOs?.tipoOs?.id,
          idClienteServico: idClienteServico,
          erpId,
        },
        { signal },
      );

      setAgendaOsAutomatico(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal?.aborted) {
        setLoadingAgenda(false);
      }
    }
  };

  const getHorariosDisponiveis = async (signal) => {
    setLoadingData(true);
    try {
      const response = await api.post(
        "/interno/find/horariosDisponiveisAgenda",
        {
          idAgenda: paramsAberturaOs?.agenda?.id,
          idTipoOs: paramsAberturaOs?.tipoOs?.id,
          idClienteServico: idClienteServico,
          erpId,
        },
        { signal },
      );
      setDatasOsAutomatica(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal?.aborted) {
        setLoadingData(false);
      }
    }
  };
  function formatarNome(nome) {
    if (!nome) return "";

    return nome
      .toLowerCase() // tudo minúsculo
      .replace(/_/g, " ") // troca underscore por espaço
      .replace(/\s+/g, " ") // remove espaços extras
      .trim() // remove espaços no início/fim
      .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase()); // primeira letra de cada palavra maiúscula
  }

  const verificationCamposOsAutomatico = () => {
    if (tipoAgendamento === "automatico") {
      const verification = {
        disabledAgenda: !paramsAberturaOs?.tipoOs?.id ? true : false,
        disabledTecnicos: !paramsAberturaOs?.hora_inicio_programado
          ? true
          : false,

        disabledData: !paramsAberturaOs?.agenda?.id ? true : false,
        disabledHorario: !paramsAberturaOs?.data_inicio_programado
          ? true
          : false,
        agenda: agendaOsAutomatico || [],
        tecnicos: horaSelecionada?.tecnicos || [],
      };

      return verification;
    } else {
      return {
        disabledAgenda: false,
        disabledTecnicos: false,
        agenda: agenda,
        tecnicos: tecnicos,
      };
    }
  };

  const optionsOriginal = verificationCamposOsAutomatico()?.tecnicos || [];
  const allSelected =
    optionsOriginal?.length > 0 &&
    tecnicosSelecionados?.length === optionsOriginal?.length;
  // Adiciona a opção "Selecionar Todos" no topo da lista de opções
  const autocompleteOptions =
    optionsOriginal?.length > 0
      ? [
          { id: "select-all", name: "Selecionar Todos", isSelectAll: true },
          ...optionsOriginal,
        ]
      : [];
  const ListboxComponent = React.forwardRef(
    function ListboxComponent(props, ref) {
      const { children, ...other } = props;
      const itemData = React.Children.toArray(children);
      const itemCount = itemData.length;
      const itemSize = 56; // Altura aproximada de cada linha (li) em pixels

      return (
        <div ref={ref} {...other}>
          <FixedSizeList
            height={250} // Altura máxima da caixinha do menu suspenso
            width="100%"
            itemSize={itemSize}
            itemCount={itemCount}
            outerElementType={React.forwardRef((props, ref) => (
              <div ref={ref} {...props} />
            ))}
            innerElementType="ul"
            itemData={itemData}
          >
            {({ data, index, style }) => {
              // Aplica o posicionamento absoluto necessário pela virtualização na linha do MUI
              return React.cloneElement(data[index], {
                style: {
                  ...style,
                  ...data[index].props.style,
                  margin: 0,
                  boxSizing: "border-box",
                },
              });
            }}
          </FixedSizeList>
        </div>
      );
    },
  );
  return (
    <>
      <Box sx={styles.boxBodyModal}>
        <Paper variant="outlined" elevation={0} sx={styles.containerPaperModal}>
          <Grid
            container
            spacing={2}
            columns={{
              xs: 6,
              sm: 6,
              smx: 6,
              md: 6,
              lg: 6,
              xl: 6,
              xxl: 6,
            }}
          >
            {!editOs && (
              <>
                <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                  <FormControl component="fieldset" fullWidth>
                    <FormLabel
                      component="legend"
                      sx={{
                        fontSize: "0.875rem",
                        fontWeight: 600,
                        marginBottom: 1,
                        color: "text.secondary",
                      }}
                    >
                      Tipo de Agendamento
                    </FormLabel>

                    <RadioGroup
                      row
                      aria-label="tipo-agendamento"
                      name="tipoAgendamento"
                      value={tipoAgendamento}
                      onChange={(e) => setTipoAgendamento(e.target.value)}
                      sx={{ gap: 2 }} // Espaçamento elegante entre as opções
                    >
                      {/* Opção: Manual */}
                      <Box
                        sx={{
                          ...styles.boxSelectTipo,
                          borderColor:
                            tipoAgendamento === "manual"
                              ? "primary.main"
                              : "divider",

                          backgroundColor:
                            tipoAgendamento === "manual"
                              ? "action.hover"
                              : "transparent",
                        }}
                      >
                        <FormControlLabel
                          value="manual"
                          control={<Radio size="small" />}
                          label={
                            <Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                Manual
                              </Typography>
                            </Box>
                          }
                          sx={{ width: "100%", margin: 0 }}
                        />
                      </Box>

                      {/* Opção: Automático */}
                      <Box
                        sx={{
                          ...styles.boxSelectTipo,
                          borderColor:
                            tipoAgendamento === "automatico"
                              ? "primary.main"
                              : "divider",

                          backgroundColor:
                            tipoAgendamento === "automatico"
                              ? "action.hover"
                              : "transparent",
                        }}
                      >
                        <FormControlLabel
                          value="automatico"
                          control={<Radio size="small" />}
                          label={
                            <Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500 }}
                              >
                                Automático
                              </Typography>
                            </Box>
                          }
                          sx={{ width: "100%", margin: 0 }}
                        />
                      </Box>
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
                  <Divider />
                </Grid>
                <Divider />
              </>
            )}

            <Grid item xs={6} sm={3} md={3}>
              <Box sx={styles.boxTextField}>
                <VirtualizedAutocomplete
                  size="small"
                  options={tipoOs}
                  disabled={loadingParams || loadingCreateOs}
                  value={
                    tipoOs.find(
                      (item) => item.id === paramsAberturaOs?.tipoOs?.id,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.tipoOs?.id
                  }
                  getOptionLabel={(option) => option?.descricao || ""}
                  onChange={(event, value) => {
                    setParamsAberturaOs((prev) => ({
                      ...prev,
                      tipoOs: {
                        id: value?.id,
                        descricao: value?.descricao,
                      },
                    }));
                  }}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="filled"
                      error={error && !paramsAberturaOs?.tipoOs?.id}
                      helperText={
                        error &&
                        !paramsAberturaOs?.tipoOs?.id &&
                        "Campo obrigatório"
                      }
                      label="Tipo de OS"
                    />
                  )}
                />
                {loadingParams && <LinearProgress sx={styles.linearProgres} />}
              </Box>
            </Grid>
            <Grid item xs={6} sm={3} md={3}>
              <Box sx={styles.boxTextField}>
                <VirtualizedAutocomplete
                  size="small"
                  options={statusOs} // Ex: ["aguardando_agendamento", "finalizado"]
                  disabled={
                    loadingParams ||
                    loadingCreateOs ||
                    tipoAgendamento === "automatico"
                  }
                  value={
                    statusOs.find(
                      (item) =>
                        item?.trim() === paramsAberturaOs?.statusOs?.trim(),
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) => option === value}
                  // AQUI: Transforma "aguardando_agendamento" em "Aguardando Agendamento" apenas na tela
                  getOptionLabel={(option) => formatarNome(option)}
                  // SOLUÇÃO PARA A LISTA NÃO SUMIR:
                  // Se o texto no campo for a versão formatada do item selecionado, ignora o filtro e mostra tudo.
                  filterOptions={(options, state) => {
                    const displayValue = formatarNome(
                      paramsAberturaOs?.statusOs,
                    );
                    if (state.inputValue === displayValue) {
                      return options;
                    }
                    // Filtra comparando o que foi digitado com o label formatado
                    return options.filter((option) =>
                      formatarNome(option)
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase()),
                    );
                  }}
                  onChange={(event, value) => {
                    setParamsAberturaOs((prev) => ({
                      ...prev,
                      statusOs: value || "",
                    }));
                  }}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="filled"
                      error={error && !paramsAberturaOs?.statusOs}
                      helperText={
                        error &&
                        !paramsAberturaOs?.statusOs &&
                        "Campo obrigatório"
                      }
                      label="Status da OS"
                    />
                  )}
                />
                {loadingParams && <LinearProgress sx={styles.linearProgres} />}
              </Box>
            </Grid>
            <Grid item xs={6} sm={3} md={3}>
              <Box sx={styles.boxTextField}>
                <VirtualizedAutocomplete
                  size="small"
                  options={verificationCamposOsAutomatico()?.agenda || []}
                  value={
                    agenda?.find(
                      (item) => item?.id === paramsAberturaOs?.agenda?.id,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) =>
                    option ? `${option?.descricao || ""} ` : ""
                  }
                  onChange={(event, value) => {
                    setParamsAberturaOs((prev) => ({
                      ...prev,
                      agenda: {
                        id: value?.id,
                        descricao: value?.descricao,
                      },
                    }));
                  }}
                  sx={{
                    width: "100%",
                  }}
                  disabled={
                    loadingParams ||
                    loadingCreateOs ||
                    verificationCamposOsAutomatico()?.disabledAgenda ||
                    loadingAgenda
                  }
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      variant="filled"
                      error={error && !paramsAberturaOs?.agenda?.id}
                      helperText={
                        error &&
                        !paramsAberturaOs?.agenda?.id &&
                        "Campo obrigatório"
                      }
                      {...params}
                      label="Agenda"
                    />
                  )}
                />
                {(loadingParams || loadingAgenda) && (
                  <LinearProgress sx={styles.linearProgres} />
                )}
              </Box>
            </Grid>
            <Grid item xs={6} sm={3} md={3}>
              <Box sx={styles.boxTextField}>
                <VirtualizedAutocomplete
                  multiple
                  limitTags={3}
                  size="small"
                  options={disponibilidade}
                  disabled={loadingParams || loadingCreateOs}
                  value={disponibilidadeSelecionada}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) => option?.descricao || ""}
                  onChange={(event, value) => {
                    setDisponibilidadeSelecionada(value);

                    setParamsAberturaOs((prev) => ({
                      ...prev,

                      disponibilidade: value || [],
                    }));
                  }}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={
                        error &&
                        (paramsAberturaOs?.disponibilidade?.length === 0 ||
                          !paramsAberturaOs?.disponibilidade)
                      }
                      helperText={
                        error &&
                        (paramsAberturaOs?.disponibilidade?.length === 0 ||
                          !paramsAberturaOs?.disponibilidade)
                          ? "Campo obrigatório"
                          : ""
                      }
                      size="small"
                      variant="filled"
                      label="Disponibilidade"
                    />
                  )}
                />
                {loadingParams && <LinearProgress sx={styles.linearProgres} />}
              </Box>
            </Grid>
            {tipoAgendamento === "manual" ? (
              <>
                <Grid item xs={6} sm={3} md={3}>
                  <Box sx={styles.boxTextField}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="pt-br"
                    >
                      <DateTimePicker
                        label="Data início"
                        size="small"
                        value={startDate}
                        minDateTime={dayjs()}
                        disabled={loadingParams || loadingCreateOs}
                        // Removido minDateTime para permitir a seleção e mostrar o erro customizado
                        onChange={(newValue) => {
                          setDateEdited(true);

                          setStartDate(newValue);
                          if (newValue && dayjs(newValue).isValid()) {
                            setEndDate(dayjs(newValue).add(1, "hour"));
                          }
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            variant: "filled",
                            // O erro dispara se estiver vazio OU se a data for passada quando error for true
                            error:
                              error &&
                              (!startDate ||
                                dayjs(startDate).isBefore(dayjs())),
                            helperText: (() => {
                              if (error && !startDate)
                                return "Campo obrigatório";
                              if (
                                error &&
                                startDate &&
                                dayjs(startDate).isBefore(dayjs())
                              ) {
                                return "A data de início não pode ser anterior ao horário atual";
                              }
                              return "";
                            })(),
                          },
                          popper: { placement: "bottom" },
                          day: {
                            sx: {
                              "&.Mui-selected": {
                                background: theme.palette.gradient.orangeMain,
                                color: theme.palette.white.main,
                              },
                              "&.Mui-selected:hover": {
                                background: theme.palette.gradient.orangeMain,
                              },
                            },
                          },
                        }}
                      />
                      {loadingParams && (
                        <LinearProgress sx={styles.linearProgres} />
                      )}
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box sx={styles.boxTextField}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="pt-br"
                    >
                      <DateTimePicker
                        label="Data fim"
                        size="small"
                        value={endDate}
                        disabled={loadingParams || loadingCreateOs}
                        onChange={(newValue) => setEndDate(newValue)}
                        // Define o limite mínimo visual
                        minDateTime={
                          startDate && dayjs(startDate).isValid()
                            ? dayjs(startDate)
                            : undefined
                        }
                        // Define o limite máximo visual (24h)
                        maxDateTime={
                          startDate && dayjs(startDate).isValid()
                            ? dayjs(startDate).add(24, "hour")
                            : undefined
                        }
                        shouldDisableTime={(value, view) => {
                          if (!startDate || !value) return false;

                          // Se a data escolhida for igual à data de início,
                          // desabilitamos tempos menores ou IGUAIS ao início
                          if (dayjs(value).isSame(dayjs(startDate), "day")) {
                            return (
                              value.isBefore(dayjs(startDate)) ||
                              value.isSame(dayjs(startDate))
                            );
                          }
                          return false;
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            variant: "filled",
                            error: !!(
                              (error && !endDate) ||
                              (endDate &&
                                startDate &&
                                (dayjs(endDate).isBefore(dayjs(startDate)) ||
                                  dayjs(endDate).isSame(dayjs(startDate)) ||
                                  dayjs(endDate).isAfter(
                                    dayjs(startDate).add(24, "hour"),
                                  )))
                            ),
                            helperText:
                              error && !endDate
                                ? "Campo obrigatório"
                                : endDate &&
                                    startDate &&
                                    (dayjs(endDate).isBefore(
                                      dayjs(startDate),
                                    ) ||
                                      dayjs(endDate).isSame(dayjs(startDate)))
                                  ? "A data fim deve ser posterior à data de início"
                                  : endDate &&
                                      startDate &&
                                      dayjs(endDate).isAfter(
                                        dayjs(startDate).add(24, "hour"),
                                      )
                                    ? "O intervalo não pode ser maior que 24 horas"
                                    : "",
                          },
                          popper: { placement: "bottom" },
                          day: {
                            sx: {
                              "&.Mui-selected": {
                                background: theme.palette.gradient.orangeMain,
                                color: theme.palette.white.main,
                              },
                              "&.Mui-selected:hover": {
                                background: theme.palette.gradient.orangeMain,
                              },
                            },
                          },
                        }}
                      />
                      {loadingParams && (
                        <LinearProgress sx={styles.linearProgres} />
                      )}
                    </LocalizationProvider>
                  </Box>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={6} sm={3} md={3}>
                  <Box sx={styles.boxTextField}>
                    <TextField
                      select
                      label="Data do agendamento"
                      // Agora o value é o objeto completo
                      value={dataSelecionada}
                      disabled={
                        loadingParams ||
                        loadingCreateOs ||
                        verificationCamposOsAutomatico()?.disabledData ||
                        loadingAgenda ||
                        loadingData
                      }
                      onChange={handleChangeDataOs}
                      fullWidth
                      variant="filled"
                      size="small"
                      // IMPORTANTE: Controla o que aparece escrito no TextField após selecionar
                      SelectProps={{
                        renderValue: (selected) => {
                          if (!selected || !selected.data) return "";
                          return selected.data.split("-").reverse().join("/");
                        },
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Define a altura máxima em pixels (ex: ~5 itens)
                              width: "auto", // Garante que a largura se adapte ou siga o padrão
                            },
                          },
                        },
                      }}
                    >
                      {datasOsAutomatica?.datas &&
                      datasOsAutomatica.datas.length > 0 ? (
                        datasOsAutomatica.datas.map((item) => (
                          // Passamos o objeto 'item' completo no value do MenuItem
                          <MenuItem key={item?.data} value={item}>
                            {item?.data?.split("-")?.reverse().join("/")} (
                            {item?.disponiveis} vagas)
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>
                          Nenhuma data disponível para agendamento
                        </MenuItem>
                      )}
                    </TextField>
                    {(loadingParams || loadingData) && (
                      <LinearProgress sx={styles.linearProgres} />
                    )}
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box sx={styles.boxTextField}>
                    <TextField
                      select
                      label="Hora do agendamento"
                      value={horaSelecionada}
                      disabled={
                        loadingParams ||
                        loadingCreateOs ||
                        verificationCamposOsAutomatico()?.disabledHorario ||
                        loadingAgenda
                      }
                      onChange={handleChangeHorarioOs}
                      fullWidth
                      variant="filled"
                      size="small"
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Define a altura máxima em pixels (ex: ~5 itens)
                              width: "auto", // Garante que a largura se adapte ou siga o padrão
                            },
                          },
                        },
                      }}
                    >
                      {dataSelecionada?.horarios?.map((item) => (
                        // Passamos o objeto 'item' completo no value do MenuItem
                        <MenuItem key={item?.data} value={item}>
                          {item?.horario}
                        </MenuItem>
                      ))}
                    </TextField>
                    {(loadingParams || loadingData) && (
                      <LinearProgress sx={styles.linearProgres} />
                    )}
                  </Box>
                </Grid>
              </>
            )}

            <Grid item xs={6} sm={6} smx={4} md={4} lg={4} xl={4} xxl={4}>
              <Box sx={styles.boxTextField}>
                <Autocomplete
                  multiple
                  size="small"
                  options={autocompleteOptions}
                  disableCloseOnSelect
                  limitTags={1}
                  ListboxComponent={ListboxComponent}
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={(event, reason) => {
                    // Evita que o clique interno feche e abra o componente rapidamente
                    if (reason === "toggleInput") return;
                    setOpen(false);
                  }}
                  disabled={
                    loadingParams ||
                    loadingCreateOs ||
                    verificationCamposOsAutomatico()?.disabledTecnicos
                  }
                  value={tecnicosSelecionados}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  getOptionLabel={(option) => {
                    if (!option) return "";
                    return option?.email
                      ? `${option?.name} (${option?.email})`
                      : option?.name;
                  }}
                  renderTags={(value, getTagProps) => {
                    if (value?.length === 0) return null;

                    if (open) {
                      return value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        const label = option.email
                          ? `${option.name} (${option.email})`
                          : option.name;
                        return (
                          <Chip
                            key={key}
                            label={label}
                            size="small"
                            variant="outlined"
                            {...tagProps}
                            // Garante que o clique no Chip (exceto no X) abra a lista se necessário
                            style={{ ...tagProps.style, pointerEvents: "auto" }}
                          />
                        );
                      });
                    }

                    const firstItemLabel = value?.[0]?.email
                      ? `${value?.[0]?.name} (${value?.[0]?.email})`
                      : value?.[0]?.name;
                    const remainder = value.length - 1;

                    return (
                      <span
                        style={{
                          fontSize: "14px",
                          paddingLeft: "8px",
                          pointerEvents: "none", // O clique atravessa o texto resumido
                          display: "inline-block",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {firstItemLabel} {remainder > 0 ? `+${remainder}` : ""}
                      </span>
                    );
                  }}
                  onChange={(event, value) => {
                    const clickedSelectAll = value.some(
                      (option) => option.isSelectAll,
                    );
                    let updatedValue = [];
                    if (clickedSelectAll) {
                      updatedValue = allSelected ? [] : [...optionsOriginal];
                    } else {
                      updatedValue = value?.filter(
                        (option) => !option.isSelectAll,
                      );
                    }

                    setTecnicosSelecionados(updatedValue);
                    setParamsAberturaOs((prev) => ({
                      ...prev,
                      tecnicos: updatedValue,
                    }));
                  }}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...otherProps } = props;

                    if (option.isSelectAll) {
                      return (
                        <div
                          key={option.id}
                          {...otherProps}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <li
                            {...otherProps}
                            style={{ fontWeight: "bold", width: "100%" }}
                          >
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={allSelected}
                            />
                            {option.name}
                          </li>
                          <Divider style={{ width: "100%" }} />
                        </div>
                      );
                    }

                    return (
                      <li {...props} key={option.id}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.email
                          ? `${option.name} (${option.email})`
                          : option.name}
                      </li>
                    );
                  }}
                  // 2. AJUSTE DE CSS NO INPUT WRAPPER:
                  sx={{
                    width: "100%",
                    "& .MuiFilledInput-root": {
                      cursor: "pointer", // Mostra a mãozinha indicando que toda a área é clicável
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={
                        error &&
                        (paramsAberturaOs?.tecnicos?.length === 0 ||
                          !paramsAberturaOs?.tecnicos)
                      }
                      helperText={
                        error &&
                        (paramsAberturaOs?.tecnicos?.length === 0 ||
                          !paramsAberturaOs?.tecnicos) &&
                        "Campo obrigatório"
                      }
                      size="small"
                      variant="filled"
                      label="Técnicos"
                      inputProps={{
                        ...params.inputProps,
                        // Evita que cliques erráticos no input fechem o menu virtualizado de forma brusca
                        readOnly: false,
                      }}
                    />
                  )}
                />
                {loadingParams && <LinearProgress sx={styles.linearProgres} />}
              </Box>
            </Grid>
            <Grid item xs={6} sm={2} smx={2} md={2} lg={2} xl={2} xxl={2}>
              <Box sx={styles.boxTextField}>
                <VirtualizedAutocomplete
                  size="small"
                  options={prioridades}
                  value={
                    prioridades?.find(
                      (item) =>
                        item?.id ===
                        paramsAberturaOs?.prioridade?.id_prioridade,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  getOptionLabel={(option) =>
                    option?.prefixo ? formatarNome(option.prefixo) : ""
                  }
                  filterOptions={(options, state) => {
                    const displayValue = formatarNome(
                      paramsAberturaOs?.prioridade?.prefixo,
                    );

                    if (state.inputValue === displayValue) {
                      return options;
                    }

                    return options.filter((option) =>
                      formatarNome(option.prefixo)
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase()),
                    );
                  }}
                  disabled={loadingParams || loadingCreateOs}
                  onChange={(event, value) => {
                    setParamsAberturaOs((prev) => ({
                      ...prev,
                      prioridade: value
                        ? {
                            id_prioridade: value.id,
                            prefixo: value.prefixo,
                            descricao: value.descricao,
                          }
                        : { id_prioridade: "", prefixo: "" },
                    }));
                  }}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="filled"
                      label="Prioridade"
                      // VALIDAÇÃO: Verifica se o erro global está ativo e se não há ID selecionado
                      error={
                        error && !paramsAberturaOs?.prioridade?.id_prioridade
                      }
                      helperText={
                        error && !paramsAberturaOs?.prioridade?.id_prioridade
                          ? "Campo obrigatório"
                          : ""
                      }
                    />
                  )}
                />
                {loadingParams && <LinearProgress sx={styles.linearProgres} />}
              </Box>
            </Grid>
            <Grid item xs={6} sm={6} smx={6} md={6} lg={6} xl={6} xxl={6}>
              <MentionTextField
                typeMetion="os"
                disabled={loadingCreateOs}
                value={paramsAberturaOs?.descricaoAbertura || ""}
                onChange={(value) =>
                  setParamsAberturaOs((prev) => ({
                    ...prev,
                    descricaoAbertura: value,
                  }))
                }
                label="Descrição de abertura da OS"
                variant="filled"
                InputProps={{
                  inputComponent: "textarea",
                }}
                /*   disabled={loadingCreateTicket || loadingParams} */
                error={
                  error &&
                  (!paramsAberturaOs?.descricaoAbertura ||
                    paramsAberturaOs?.descricaoAbertura.length < 10)
                }
                helperText={
                  (error &&
                    !paramsAberturaOs?.descricaoAbertura &&
                    "Campo obrigatório") ||
                  (error &&
                    paramsAberturaOs?.descricaoAbertura.length > 0 &&
                    paramsAberturaOs?.descricaoAbertura.length < 10 &&
                    "A descrição deve ter no mínimo 10 caracteres")
                }
                sx={{
                  width: "100%",
                  "& .MuiInputBase-root": {
                    paddingTop: "25px",
                    paddingRight: "5px",
                    paddingBottom: "5px",
                  },
                  "& textarea": {
                    resize: "vertical",
                    minHeight: "140px",
                    padding: "10px 12px",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </>
  );
}
